module.exports = __webpack_public_path__ + "img/bb-image.1016df88.jpg";